/**
 * 表紙特集掲載商品選定（CX）画面の特集一覧クラス
 *
 * @export FeatureListInfo
 * @class FeatureListInfo
 */
export class FeatureListInfo {
  constructor(
    // 特集コード
    public Code: string,
    // 特集名
    public Name: string,
  ) {}
}
